import * as L from 'leaflet'
// import '_leaflet-polylinedecorator@1.6.0@leaflet-polylinedecorator'
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
require('@/extend/leaflet-extend.js')
// 地图初始化
export function initMap (target) {
  let map = L.CreateTianDiTuMap('myMap', {
    crs: L.CRS.EPSG4490,
    zoomControl: false,
    minZoom: 8, // 最小缩放等级
    maxZoom: 18 // 最大缩放等级
  }).setView(
    [target.$store.state.user.user.lat, target.$store.state.user.user.lng],
    7
  )
  let customArcGISServerLayer = new L.tileLayer.CustomArcGISServerLayer(
    'http://106.14.94.92:8085/NXJ/',
    { minZoom: 7, maxZoom: 16 }
  )
  customArcGISServerLayer.addTo(map)
  return map
}
export function initMap2 (target, name, viewLevel, featureGroup) {
  let map = L.CreateTianDiTuMap(name, {
    crs: L.CRS.EPSG4490,
    zoomControl: false,
    minZoom: 8, // 最小缩放等级
    maxZoom: 18 // 最大缩放等级
  }).setView(
    [target.$store.state.user.user.lat, target.$store.state.user.user.lng],
    viewLevel
  )
  let customArcGISServerLayer = new L.tileLayer.CustomArcGISServerLayer(
    'http://106.14.94.92:8085/NXJ/',
    { minZoom: 7, maxZoom: 16 }
  )
  customArcGISServerLayer.addTo(map)
  if (featureGroup) {
    let drawControl = new L.Control.Draw({
      edit: {
        featureGroup: featureGroup,
        remove: false
      },
      draw: {
        polyline: false,
        polygon: false,
        rectangle: false,
        circle: false,
        marker: false,
        circlemarker: false
      }
    })
    featureGroup.addTo(map)
    L.drawLocal.draw.toolbar.finish.title = '完成标绘'
    L.drawLocal.draw.toolbar.finish.text = '完成'
    L.drawLocal.draw.toolbar.undo.title = '删除最后一点绘制'
    L.drawLocal.draw.toolbar.undo.text = '删除最后点'
    L.drawLocal.draw.toolbar.actions.title = '取消标绘'
    L.drawLocal.draw.toolbar.actions.text = '取消'
    L.drawLocal.draw.toolbar.buttons.polygon = '绘制面'
    L.drawLocal.draw.toolbar.buttons.polyline = '绘制线'
    L.drawLocal.draw.toolbar.buttons.marker = '绘制点'
    L.drawLocal.draw.handlers.polygon.tooltip.start = '点击开始绘制区域'
    L.drawLocal.draw.handlers.polyline.tooltip.start = '点击开始绘制线'
    L.drawLocal.draw.handlers.marker.tooltip.start = '点击开始绘制点'
    L.drawLocal.draw.handlers.polygon.tooltip.cont = '单击继续绘制区域'
    L.drawLocal.draw.handlers.polyline.tooltip.cont = '单击继续绘制线'
    L.drawLocal.draw.handlers.polygon.tooltip.end = '单击第一个点以关闭此区域'
    L.drawLocal.draw.handlers.polyline.tooltip.end = '单击最后一个点结束绘制'
    L.drawLocal.edit.toolbar.actions.save.title = '保存编辑'
    L.drawLocal.edit.toolbar.actions.save.text = '保存'
    L.drawLocal.edit.toolbar.buttons.edit = '编辑区域'
    L.drawLocal.edit.toolbar.buttons.editDisabled = '没有可编辑的区域'
    L.drawLocal.edit.toolbar.actions.cancel.title = '取消编辑'
    L.drawLocal.edit.toolbar.actions.cancel.text = '取消'
    L.drawLocal.edit.handlers.edit.tooltip.text = '拖动手柄或标记以编辑要素'
    L.drawLocal.edit.handlers.edit.tooltip.subtext = '单击取消以撤消更改'
    L.drawLocal.edit.toolbar.actions.clearAll.title = '删除所有区域'
    L.drawLocal.edit.toolbar.actions.clearAll.text = '删除所有'
    L.drawLocal.edit.toolbar.buttons.remove = '删除区域'
    L.drawLocal.edit.toolbar.buttons.removeDisabled = '没有可删除的区域'
    L.drawLocal.edit.handlers.remove.tooltip.text = '点击要删除的区域'
    map.addControl(drawControl)
  }
  return map
}
// 设置地图marker
export function setMapMaker (
  data,
  markerGroup,
  lttdName,
  lgtdName,
  icon,
  target,
  toolTipContentName,
  idName,
  detailRefName
) {
  markerGroup.clearLayers()
  if (data !== undefined && data.length > 0) {
    data.forEach(item => {
      setMapMarkerItem3(
        item,
        markerGroup,
        lttdName,
        lgtdName,
        icon,
        target,
        toolTipContentName,
        idName,
        14,
        14,
        detailRefName
      )
    })
  }
}
export function setMapMarkerItem (target, data, color, layerGroup) {
  let prefix = data.geom.substr(0, 7)
  let mapAllData = []
  let lat = ''
  let lng = ''
  if (prefix === 'POLYGON') {
    let reg = /\(([^)]*)\)/
    let polygonData = data.geom.match(reg)[1].toString().replace(/\(+(.*?)\)*/, '$1')
    polygonData = polygonData.split(', ')
    polygonData.forEach(item1 => {
      mapAllData.push(item1.split(' ').reverse())
    })
    let pointPolIndex = parseInt(mapAllData.length / 2)
    lat = mapAllData[pointPolIndex][0]
    lng = mapAllData[pointPolIndex][1]
  } else if (prefix === 'MULTIPO') {
    let mulPolygonDatas = data.geom.substring(16, data.geom.length - 3).split(')), ((')
    let three = []
    mulPolygonDatas.forEach(ele => {
      let mulPolygonData = ele.split('), (')
      let two = []
      for (let k = 0; k < mulPolygonData.length; k++) {
        var mulPolygonDataItem = mulPolygonData[k].split(', ')
        let one = []
        mulPolygonDataItem.forEach(elem => {
          one.push(elem.split(' ').reverse())
        })
        two.push(one)
      }
      three.push(two)
    })
    mapAllData = three
    lat = mapAllData[0][0][0][0]
    lng = mapAllData[0][0][0][1]
  }
  let marker = L.polygon(mapAllData, { color: color })
  marker.bindTooltip(data.riverName)
  marker.metadata = { id: data.id, lat: lat, lng: lng }
  layerGroup.addLayer(marker)
  marker.on('click', () => {
    target.$refs.riverDetail.isShow = true
    target.$refs.riverDetail.form = data
  })
  return marker
}
export function setMapMarkerItem2 (target, tooltip, viewLevel, data, color, layerGroup, isView, isClearLayer, popupcontent) {
  if (isClearLayer) {
    layerGroup.clearLayers()
  }
  let prefix = data.geom.substr(0, 7)
  let mapAllData = []
  let lat = ''
  let lng = ''
  let marker = {}
  if (prefix === 'POLYGON' || prefix === 'MULTIPO') {
    if (prefix === 'POLYGON') {
      let reg = /\(([^)]*)\)/
      let polygonData = data.geom.match(reg)[1].toString().replace(/\(+(.*?)\)*/, '$1')
      polygonData = polygonData.split(', ')
      polygonData.forEach(item1 => {
        mapAllData.push(item1.split(' ').reverse())
      })
      let pointPolIndex = parseInt(mapAllData.length / 2)
      lat = mapAllData[pointPolIndex][0]
      lng = mapAllData[pointPolIndex][1]
    } else if (prefix === 'MULTIPO') {
      let mulPolygonDatas = data.geom.substring(16, data.geom.length - 3).split(')), ((')
      let three = []
      mulPolygonDatas.forEach(ele => {
        let mulPolygonData = ele.split('), (')
        let two = []
        for (let k = 0; k < mulPolygonData.length; k++) {
          var mulPolygonDataItem = mulPolygonData[k].split(', ')
          let one = []
          mulPolygonDataItem.forEach(elem => {
            one.push(elem.split(' ').reverse())
          })
          two.push(one)
        }
        three.push(two)
      })
      mapAllData = three
      lat = mapAllData[0][0][0][0]
      lng = mapAllData[0][0][0][1]
    }
    marker = L.polygon(mapAllData, { color: color })
    marker.bindTooltip(tooltip)
    marker.metadata = { id: data.id, lat: lat, lng: lng }
    layerGroup.addLayer(marker)
  }
  if (prefix === 'MULTILI') {
    let multiliDatas
    if (data.geom.indexOf('), (') !== -1) {
      multiliDatas = data.geom.substring(18, data.geom.length - 2).split('), (')
    } else {
      multiliDatas = data.geom.substring(18, data.geom.length - 2)
    }
    let two = []
    for (let k = 0; k < multiliDatas.length; k++) {
      var multiliDataItem = multiliDatas[k].split(', ')
      let one = []
      multiliDataItem.forEach(elem => {
        one.push(elem.split(' ').reverse())
      })
      two.push(one)
    }
    lat = two[0][0][0]
    lng = two[0][0][1]
    marker = L.polyline(two, { color: color })
    marker.bindTooltip(tooltip)
    marker.metadata = { id: data.id, lat: lat, lng: lng }
    layerGroup.addLayer(marker)
  }
  if (isView) {
    target.map.setView([marker.metadata.lat, marker.metadata.lng], viewLevel)
  }
  marker.bindPopup(popupcontent)
  return marker
}
export function setMapMarkerItem3 (
  data,
  markerGroup,
  lttdName,
  lgtdName,
  icon,
  target,
  toolTipContentName,
  idName,
  iconWSize,
  iconHSize,
  detailRefName
) {
  let marker = target.L.marker([data[lttdName], data[lgtdName]], {
    icon: target.L.icon({
      iconUrl: icon,
      iconSize: [iconWSize, iconHSize]
    })
  })
  marker.metadata = { id: data[idName] }
  let toolTipHtml = `<div class="mapToolTip">${data[toolTipContentName]}</div>`
  marker.bindTooltip(toolTipHtml, {
    permanent: false,
    direction: 'top',
    offset: [3, -4]
  })
  marker.on('click', () => {
    target.$refs[detailRefName].isShow = true
    target.$refs[detailRefName].form = data
  })
  markerGroup.addLayer(marker)
}
export function setMapMarkerItem4 (featureGroup, data, color) {
  featureGroup.removeLayer()
  if (data) {
    let newData = JSON.parse(data)
    newData.forEach(item => {
      let marker = L.polyline(item, { color: color })
      let polylineDistance = getPolylineDistance(marker)
      let popupContent = (polylineDistance).toFixed(2) + 'm'
      featureGroup.addLayer(marker)
      let popup = L.popup({ autoClose: false, closeOnClick: false }).setContent(popupContent)
      marker.bindPopup(popup).openPopup()
    })
  }
  featureGroupDelEvent(featureGroup)
}
export function setMapMarkerItem5 (target, data, color, featureGroup, detailRefName, tooltipName) {
  let prefix = data.geom.substr(0, 7)
  let resultMarker = ''
  if (prefix === 'POLYGON' || prefix === 'MULTIPO') {
    if (prefix === 'POLYGON') {
      let mapAllData = []
      let reg = /\(([^)]*)\)/
      let polygonData = data.geom.match(reg)[1].toString().replace(/\(+(.*?)\)*/, '$1')
      polygonData = polygonData.split(', ')
      polygonData.forEach(item1 => {
        mapAllData.push(item1.split(' ').reverse())
      })
      let pointPolIndex = parseInt(mapAllData.length / 2)
      let lat = mapAllData[pointPolIndex][0]
      let lng = mapAllData[pointPolIndex][1]
      resultMarker = L.polygon(mapAllData, { color: color })
      resultMarker.bindTooltip(data.riverName)
      resultMarker.metadata = { id: data.id, lat: lat, lng: lng }
      featureGroup.addLayer(resultMarker)
      resultMarker.on('click', () => {
        target.$refs[detailRefName].isShow = true
        target.$refs[detailRefName].form = data
      })
    } else if (prefix === 'MULTIPO') {
      let mulPolygonDatas = data.geom.substring(16, data.geom.length - 3).split(')), ((')
      let three = []
      mulPolygonDatas.forEach(ele => {
        let mulPolygonData = ele.split('), (')
        let two = []
        for (let k = 0; k < mulPolygonData.length; k++) {
          var mulPolygonDataItem = mulPolygonData[k].split(', ')
          let one = []
          mulPolygonDataItem.forEach(elem => {
            one.push(elem.split(' ').reverse())
          })
          two.push(one)
        }
        three.push(two)
        resultMarker = L.polygon(two, { color: color })
        resultMarker.bindTooltip(data[tooltipName])
        resultMarker.metadata = { id: data.id, lat: two[0][0][0], lng: two[0][0][1] }
        featureGroup.addLayer(resultMarker)
        resultMarker.on('click', () => {
          target.$refs[detailRefName].isShow = true
          target.$refs[detailRefName].form = data
        })
      })
    }
  }
  if (prefix === 'MULTILI') {
    let mulPolylineDatas = data.geom.substring(18, data.geom.length - 2).split('), (')
    let two = []
    for (let k = 0; k < mulPolylineDatas.length; k++) {
      var mulPolylineDataItem = mulPolylineDatas[k].split(', ')
      let one = []
      mulPolylineDataItem.forEach(elem => {
        one.push(elem.split(' ').reverse())
      })
      two.push(one)
    }
    resultMarker = L.polyline(two, { color: color })
    resultMarker.bindTooltip(data[tooltipName])
    resultMarker.metadata = { id: data.id, lat: two[0][0][0], lng: two[0][0][1] }
    featureGroup.addLayer(resultMarker)
    resultMarker.on('click', () => {
      target.$refs[detailRefName].isShow = true
      target.$refs[detailRefName].form = data
    })
  }
  if (prefix === 'LINESTR') {
    let polylineDatas = data.geom.substring(12, data.geom.length - 1)
    var polylineDatasItem = polylineDatas.split(', ')
    let one = []
    polylineDatasItem.forEach(elem => {
      one.push(elem.split(' ').reverse())
    })
    let oneLength = one.length
    let pointIndex = parseInt(oneLength / 2)
    let lat = one[pointIndex][0]
    let lng = one[pointIndex][1]
    resultMarker = L.polyline(one, { color: color })
    resultMarker.bindTooltip(data[tooltipName])
    resultMarker.metadata = { id: data.id, lat: lat, lng: lng }
    featureGroup.addLayer(resultMarker)
    resultMarker.on('click', () => {
      target.$refs[detailRefName].isShow = true
      target.$refs[detailRefName].form = data
    })
  }
  return resultMarker
}
export function setMapMarkerItem6 (target, tooltip, viewLevel, data, index, color, layerGroup, isView, isClearLayer, popupcontent) {
  if (isClearLayer) {
    layerGroup.clearLayers()
  }
  let prefix = data.giszb[index].geom.substr(0, 7)
  let mapAllData = []
  let lat = ''
  let lng = ''
  let marker = {}
  if (prefix === 'POLYGON' || prefix === 'MULTIPO') {
    if (prefix === 'POLYGON') {
      let reg = /\(([^)]*)\)/
      let polygonData = data.giszb[index].geom.match(reg)[1].toString().replace(/\(+(.*?)\)*/, '$1')
      polygonData = polygonData.split(', ')
      polygonData.forEach(item1 => {
        mapAllData.push(item1.split(' ').reverse())
      })
      let pointPolIndex = parseInt(mapAllData.length / 2)
      lat = mapAllData[pointPolIndex][0]
      lng = mapAllData[pointPolIndex][1]
    } else if (prefix === 'MULTIPO') {
      let mulPolygonDatas = data.giszb[index].geom.substring(16, data.giszb[index].geom.length - 3).split(')), ((')
      let three = []
      mulPolygonDatas.forEach(ele => {
        let mulPolygonData = ele.split('), (')
        let two = []
        for (let k = 0; k < mulPolygonData.length; k++) {
          var mulPolygonDataItem = mulPolygonData[k].split(', ')
          let one = []
          mulPolygonDataItem.forEach(elem => {
            one.push(elem.split(' ').reverse())
          })
          two.push(one)
        }
        three.push(two)
      })
      mapAllData = three
      lat = mapAllData[0][0][0][0]
      lng = mapAllData[0][0][0][1]
    }
    if (data.giszb[index].typeName === '高危险区') {
      color = '#FFA500'
    } else if (data.giszb[index].typeName === '极高危险区') {
      color = '#FF0000'
    }
    marker = L.polygon(mapAllData, { color: color, zIndex: 10000 })
    marker.bindTooltip(tooltip)
    marker.metadata = { id: data.id, lat: lat, lng: lng }
    layerGroup.addLayer(marker)
  }
  if (prefix === 'MULTILI') {
    let multiliDatas
    if (data.giszb[index].geom.indexOf('), (') !== -1) {
      multiliDatas = data.geom.substring(18, data.giszb[index].geom.length - 2).split('), (')
    } else {
      multiliDatas = data.giszb[index].geom.substring(18, data.giszb[index].geom.length - 2)
    }
    let two = []
    for (let k = 0; k < multiliDatas.length; k++) {
      var multiliDataItem = multiliDatas[k].split(', ')
      let one = []
      multiliDataItem.forEach(elem => {
        one.push(elem.split(' ').reverse())
      })
      two.push(one)
    }
    lat = two[0][0][0]
    lng = two[0][0][1]
    marker = L.polyline(two, { color: color })
    marker.bindTooltip(tooltip)
    marker.metadata = { id: data.id, lat: lat, lng: lng }
    layerGroup.addLayer(marker)
  }
  if (isView) {
    target.map.setView([marker.metadata.lat, marker.metadata.lng], viewLevel)
  }
  marker.bindPopup(popupcontent)
  return marker
}
// 设置地图选中marker
export function selectMapMarker (target, oldVal, val, layerGroup, normalColor, selectColor) {
  if (oldVal.id) {
    Object.keys(layerGroup._layers).forEach(key => {
      let item = layerGroup._layers[key]
      if (item.metadata.id === oldVal.id) {
        layerGroup.removeLayer(item)
        setMapMarkerItem(target, oldVal, normalColor, layerGroup)
      }
    })
  }
  let marker = setMapMarkerItem(target, val, selectColor, layerGroup)
  target.map.setView([marker.metadata.lat, marker.metadata.lng], 11)
}
export function selectMapMarker2 (target, oldVal, val, layerGroup, normalColor, selectColor, featureGroup, viewLevel, detailRefName, tooltipName) {
  if (oldVal.id) {
    Object.keys(layerGroup._layers).forEach(key => {
      let item = layerGroup._layers[key]
      if (item.metadata.id === oldVal.id) {
        layerGroup.removeLayer(item)
      }
      setMapMarkerItem(target, oldVal, normalColor, layerGroup)
    })
  }
  featureGroup.clearLayers()
  let marker = setMapMarkerItem5(target, val, selectColor, featureGroup, detailRefName, tooltipName)
  target.map.setView([marker.metadata.lat, marker.metadata.lng], viewLevel)
}
// featureGroup删除layer监听事件
export function featureGroupDelEvent (featureGroup) {
  Object.keys(featureGroup._layers).forEach(key => {
    let item = featureGroup._layers[key]
    item.on('dblclick', () => {
      featureGroup.removeLayer(item)
    })
  })
}
// 地图标绘
export function mapDraw (target, type, imgUrl, color, featureGroup) {
  switch (type) {
    case 'line':
      new L.Draw.Polyline(target.map).enable()
      break
    case 'area':
      new L.Draw.Polygon(target.map).enable()
      break
    default:
      new L.Draw.Marker(target.map).enable()
      break
  }
  target.map.on('draw:created', event => {
    let tempMarker
    let popupContent = ''
    switch (event.layerType) {
      case 'marker':
        let myIcon = L.icon({
          iconUrl: require(imgUrl),
          iconSize: [28, 28],
          shadowSize: [28, 28],
          iconAnchor: [8, 8]
        })
        let latLng = [
          event.layer.getLatLng().lat,
          event.layer.getLatLng().lng
        ]
        tempMarker = L.marker(latLng, { icon: myIcon })
        break
      case 'polyline':
        let latLngsArrayLine = []
        let latLngsLine = Object.assign([], event.layer.getLatLngs())
        latLngsLine.forEach(item => {
          latLngsArrayLine.push([item.lat, item.lng])
        })
        tempMarker = L.polyline(latLngsArrayLine, {
          color: color,
          draggable: 'true'
        })
        let polylineDistance = getPolylineDistance(tempMarker)
        popupContent = (polylineDistance).toFixed(2) + 'm'
        break
      case 'polygon':
        let latLngsArrayGon = []
        let latLngsGon = Object.assign([], event.layer.getLatLngs()[0])
        latLngsGon.forEach(item => {
          latLngsArrayGon.push([item.lat, item.lng])
        })
        tempMarker = L.polygon([latLngsArrayGon], {
          color: color,
          draggable: 'true'
        })
        break
      default:
        break
    }
    featureGroup.addLayer(tempMarker)
    if (popupContent) {
      let popup = L.popup({ autoClose: false, closeOnClick: false }).setContent(popupContent)
      tempMarker.bindPopup(popup).openPopup()
    }
    featureGroupDelEvent(featureGroup)
  })
}
// 获取featureGroup 经纬度数据
export function getFeatureGroupLatLngsData (featureGroup) {
  let result = []
  Object.keys(featureGroup._layers).forEach(key => {
    let item = featureGroup._layers[key]
    result.push(item.getLatLngs())
  })
  result = JSON.stringify(result)
  return result
}
export function getFeatureGroupLatLngsData2 (featureGroup) {
  let result = []
  let count = 0
  let returnResult = ''
  Object.keys(featureGroup._layers).forEach(key => {
    count = count + 1
    let item = featureGroup._layers[key]
    result.push(item.getLatLngs())
  })
  if (count === 1) {
    returnResult = `POLYGON ((${getFeatureGroupLatLngsData2Detail(result[0][0], true)}))`
  } else {
    let two = ''
    result.forEach(item => {
      let one = ''
      item.forEach(item1 => {
        one += `(${getFeatureGroupLatLngsData2Detail(item1, true)}), `
      })
      if (one) {
        let oneLength = one.length
        two += `(${one.substr(0, oneLength - 2)}), `
      }
    })
    if (two) {
      let twoLength = two.length
      returnResult = `MULTIPOLYGON (${two.substr(0, twoLength - 2)})`
    }
  }
  return returnResult
}
export function getFeatureGroupLatLngsData3 (featureGroup) {
  let result = []
  let returnResult = ''
  Object.keys(featureGroup._layers).forEach(key => {
    let item = featureGroup._layers[key]
    result = item.getLatLngs()
  })
  if (Object.prototype.toString.call(result[0]) === '[object Object]') {
    returnResult = `LINESTRING (${getFeatureGroupLatLngsData2Detail(result, false)})`
  } else {
    result.forEach(item => {
      returnResult += `(${getFeatureGroupLatLngsData2Detail(item, false)}), `
    })
    if (returnResult) {
      let returnResultLength = returnResult.length
      returnResult = `MULTILINESTRING (${returnResult.substr(0, returnResultLength - 2)})`
    }
  }
  return returnResult
}
function getFeatureGroupLatLngsData2Detail (data, isAddFirstPoint) {
  let returnResult = ''
  let firstLocation = {}
  data.forEach((item, index) => {
    if (index === 0) {
      firstLocation = item
    }
    returnResult += `${item.lng} ${item.lat}, `
  })
  if (returnResult !== '') {
    if (isAddFirstPoint) {
      returnResult += `${firstLocation.lng} ${firstLocation.lat}`
    } else {
      let returnResultLength = returnResult.length
      returnResult = returnResult.substr(0, returnResultLength - 2)
    }
  }
  return returnResult
}
// 获取绘制的线的距离
function getPolylineDistance (marker) {
  let tempLatLng = null
  let totalDistance = 0.00000
  marker._latlngs.forEach(latlng => {
    if (tempLatLng == null) {
      tempLatLng = latlng
      return
    }
    totalDistance += tempLatLng.distanceTo(latlng)
    tempLatLng = latlng
  })
  return totalDistance
}
// 展示tooltip
export function selectMapLayer (target, data, featureGroup, index, openPop, zoom) {
  Object.keys(featureGroup._layers).forEach(key => {
    let item = featureGroup._layers[key]
    if (item && item.metadata) {
      if (item.metadata.adcd === data.adcd) {
        if (openPop) {
          item.openTooltip()
          item.openPopup()
          target.markerPopup = true
          let riverStationPopup = target.$refs['markerPopup']
          let rainfallPopupCcontent = document.getElementById('marker_popup' + index)
          target.pointIndex = index
          target.activeName = '1'
          rainfallPopupCcontent.appendChild(riverStationPopup)
          target.$nextTick(() => {
            let pop = riverStationPopup.parentNode.parentNode.parentNode.parentNode
            pop.style.left = '-205px'
          })
        }
        item.openTooltip()
        target.map.setView([item.metadata.lat, item.metadata.lng], zoom || 11)
      } else {
        item.closeTooltip()
        item.closePopup()
      }
    }
  })
}
// 测站展示tooltip
export function selectMapLayer1 (target, data, featureGroup) {
  Object.keys(featureGroup._layers).forEach(key => {
    let item = featureGroup._layers[key]
    if (item && item.metadata) {
      if (item.metadata.stid === (data.stid || data.id)) {
        item.openTooltip()
        target.map.setView([item.metadata.lat, item.metadata.lng], 11)
      } else {
        item.closeTooltip()
      }
    }
  })
}
